import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const MRLDetailReport = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/standardreport");
  };
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [farmActivityData, setFarmActivityData] = useState([]);
  const [farmActivityId, setFarmActivityId] = useState();

  const { sendRequest: getWarehouseData } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    FillReport(id);
  };

  const FillReport = (employeeId) => {
    var d = new Date(selectedToDate);

    d.setDate(d.getDate() + 1);
    setCurrentPage(1);
    //console.log("d", d);
    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    //var tdate=moment(selectedToDate).format("DD/MM/YYYY");

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    var url = `/api/mrlDetailReportMIS/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getFiedlActivity } = useHttp();
  useEffect(() => {
    getFiedlActivity(
      {
        url: `/api/farmActivity/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("farmActivity", data);

        setFarmActivityData(data);
      }
    );
  }, [getFiedlActivity]);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        // //console.log("emp",data.output )
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
        // var myFDate = new Date(fromSelectedDate );
        // var myTDate = new Date(toSelectedDate );
        // genrateDatelist(myFDate, myTDate );
        // setSelectedDate(format(myFDate, dateFormat) );
      }
    );
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data);
      }
    );
  }, [getRegion]);

  const fieldsToExport = [
    "sampleDate",
    "sampleNo",
    "farmManager",
    "plotName",
    "plotArea",
    "plotAreaUnit",
    "cropName",
    "varietyName",
    "sampleQuantity",
    "sampleQuantityUnit",
    "mrlStatus",
    "proposedHarvestDate",
    "labName",
    "mrlTestCost",
  ];

  const customHeaders = [
    "Sample Date",
    "Doc No",
    "Farm Manager",
    "Plot Name",
    "Plot Area",
    "Unit",
    "Crop Name",
    "Variety Name",
    "Sample Quantity",
    "Sample Quantity Unit",
    "MRL Status",
    "Proposed Harvest Date",
    "Laboratory",
    "MRL Test Cost",
  ];

  const handleExportExcel = () => {
    const filename = "MRL.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Field MRL Detail Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <hr />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <h3>
              Field MRL Detail Report
              </h3>
           
            </div>
            <hr />
            <div className="row">
              </div>
            <div className="row">
            
            <div className="col-md-3">
            <div className="form-group">
            <label htmlFor={"executive_officer"}>{"Procurement Officer"}</label>
            <select
              id="emp_id"
              className="form-control"
              ref={(el) => (frmRef.current["emp_id"] = el)}
              value={employeeId}
              onChange={(e) => {

                var userid=0;
                if(e.target.value!="--Select--")
                   userid=e.target.value;

                setEmployeeId(userid);
                setData([]);
             
              }}
            >
              <option>--Select--</option>
              {employeeData &&
                employeeData.map((x) => (
                  <option key={x.userId} user-id={x.userId} value={x.userId}>
                    {x.employeeName}
                  </option>
                ))}
            </select>
          </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
            {" "}
            <label htmlFor={"from_date"}>{"From Date"}</label>
            <input
              type={"date"}
              id={"date"}
              required
              // ref={(el) => (frmRef.current["pdate"] = el)}
               className="form-control"
              max={currentDate}
              value={selectedFromDate}
              onChange={handleFDateChange}
            />
          </div>

          </div>
          <div className="col-md-2">
            <div className="form-group">
            <label  >{"To Date"}</label>

            <input
              type={"date"}
              id={"date"}
              required
              // ref={(el) => (frmRef.current["pdate"] = el)}
               className="form-control"
              max={currentDate}
              value={selectedToDate}
              onChange={handleTDateChange}
            />
          </div>

           
          </div>
          <div className="col-md-2">
            <div className="form-group">
               
               <label>&nbsp;</label>
                <button
                  className="form-control btn btn-sm btn-primary"
                  onClick={(e) => {
                    FillReport(employeeId,regionId);
                  }}
                >
                  Submit
                </button>
              </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>

              <div className="col-md-3"></div>
            </div>
          </div>
          <h5 className="text-dark">
            Please select the parameters to get the desired result
          </h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Sample Date </th>
                          <th> Doc No </th>
                          <th>Farm Manager</th>

                          <th>Plot Name </th>
                          <th> Plot Area </th>
                          <th> Unit </th>
                          <th> Crop Name </th>
                          <th>Variety Name </th>

                          <th>Sample Quantity </th>
                          <th>Sample Quantity Unit </th>
                          <th>MRL Status</th>

                          <th>Proposed Harvest Date</th>

                          <th> Laboratory </th>
                          <th> MRL Test Cost </th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.sampleDate}</td>
                        <td>{itm.sampleNo}</td>

                        <td>{itm.farmManager}</td>

                        <td>{itm.plotName}</td>

                        <td> {itm.plotArea} </td>
                        <td> {itm.plotAreaUnit} </td>
                        <td> {itm.cropName} </td>
                        <td> {itm.varietyName} </td>

                        <td> {itm.sampleQty}	 </td>
                        <td> {itm.sampleUnit}	 </td>
                        <td> {itm.mrlStatus}	 </td>
                        <td> {itm.proposedHarvestDate}	 </td>

                        <td> {itm.labName} </td>

                        <td> {itm.mrlTestCost} </td>
                     
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MRLDetailReport;
